export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') },
	'collegeTour': { id: 'collegeTour', page: 'customScroll', getter: () => import(/* webpackChunkName: 'customScroll' */ 'components/bolt/customScroll/customScroll') }
};
import text from 'components/bolt/text/text';
import gallery from 'components/bolt/gallery/gallery';
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "synopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis', parent: 'boltHome' },
	{ id: 'boltFeaturedVideos', getter: () => import(/* webpackChunkName: "featuredVideos" */ 'components/bolt/featuredVideos/featuredVideos'), component: 'featuredVideos', parent: 'boltHome' },
	{ id: 'intro', isPreloaded: true, component: text, parent: 'collegeTour' },
	{ id: 'gallery', isPreloaded: true, component: gallery, parent: 'collegeTour' }
];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
